import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// 🔹 Pagini LEGAL
import PoliticaConfidentialitate from "./pages/plitica-cofidentialitate";
import PoliticaCookie from "./pages/politica-cookie";
import TermeniSiConditii from "./pages/termeni-si-conditii";
import GdprRequest from "./pages/gdpr-request";

// 🔹 Pagini principale
import Navbar from "./pages/Navbar";
import Hero from "./pages/Hero";
import DespreStefan from "./pages/despre_stefan";
import SimulareTraseu from "./pages/SimulareTraseu";
import AntrenamenteOnline from "./pages/AntrenamenteOnline";
import Recenzii from "./pages/Recenzii";
import { Flooter } from "./pages/Flooter";

// 🔹 Admin & Auth
import AdminPanel from "./pages/AdminPanel";
import Login from "./pages/Login";
import { Register } from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ProgressCategoryPage from "./pages/ProgressCategoryPage";
import AdminUserProgressPage from "./pages/AdminUserProgressPage";
import AdminAttendancePage from "./pages/AdminAttendancePage";
import AdminUsersPage from "./pages/AdminUsersPage";

import CookieConsent from "./components/CookieConsent";

gsap.registerPlugin(ScrollTrigger);

const App = () => {
  useEffect(() => {
    const ctx = gsap.context(() => {
      const textSelectors =
        "h1, h2, h3, h4, h5, h6, p, span, li, label, small, .text-element";
      const containerSelectors =
        "section, article, .animate-container, .card, .panel, .box, .despre-container, .simulare-content, .simulare-card, .ao-container, form";
      const shouldSkip = (el) =>
        el.closest("nav") ||
        el.closest(".mobile-nav-drawer") ||
        el.closest(".admin-page") ||
        el.closest("footer") ||
        el.closest(".flooter-container");

      gsap.utils.toArray(textSelectors).forEach((el) => {
        if (shouldSkip(el)) return;
        gsap.fromTo(
          el,
          { autoAlpha: 0, y: 15 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 85%",
              toggleActions: "play none none reverse",
            },
          }
        );
      });

      gsap.utils.toArray(containerSelectors).forEach((el) => {
        if (shouldSkip(el)) return;
        gsap.fromTo(
          el,
          { autoAlpha: 0, y: 40 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: el,
              start: "top 90%",
              toggleActions: "play none none reverse",
            },
          }
        );
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <Router>
      <CookieConsent />

      <Routes>
        {/* ======================= HOME PAGE ======================= */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Hero />
              <DespreStefan />
              <SimulareTraseu />
              <AntrenamenteOnline />
              <Recenzii />
              <Flooter />
            </>
          }
        />

        {/* ======================= LEGAL PAGES ======================= */}
        <Route
          path="/politica-confidentialitate"
          element={<PoliticaConfidentialitate />}
        />
        <Route path="/politica-cookie" element={<PoliticaCookie />} />
        <Route path="/termeni-si-conditii" element={<TermeniSiConditii />} />
        <Route path="/gdpr-request" element={<GdprRequest />} />

        {/* ======================= ADMIN ======================= */}
        <Route path="/adminpage" element={<AdminPanel />} />
        <Route
          path="/admin/progres/:userId/:tip"
          element={<AdminUserProgressPage />}
        />
        <Route path="/admin/prezenta" element={<AdminAttendancePage />} />
        <Route path="/admin/utilizatori" element={<AdminUsersPage />} />
        <Route path="/progres/:category" element={<ProgressCategoryPage />} />

        {/* ======================= AUTH ======================= */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Routes>
    </Router>
  );
};

export default App;
